import React, { useEffect, useState } from "react";
import CpntDataTable from "../../components/dataTable/CpntDataTable";
//import CpntFacette from "../../components/CpntFacette";
import { IFilterCompte, IFilterCompteDTO, dtoToFilter, filterToQuery, getDefaultFilterCompte } from "../../models/interfaces/IFilterCompte";
import { ITitle } from "../../models/interfaces/ITitle";
import { ICompteList } from "../../models/interfaces/ICompte";
import ComptesFilter from "./MonCompte/ComptesFilter";
import { useFetchComptesQuery } from "../../redux/slice/api/FO/compteApi";
import { ISorter } from "../../models/interfaces/ISorter";
import { ILocation } from "../../models/interfaces/ILocation";
import { useKeycloak } from "@react-keycloak/web";
import { Link } from "react-router-dom";
import CpntPagination from "../../components/CpntPagination";
import SpinnerEditeurPro from "./components/SpinnerEditeurPro";
import HtmlRenderActifToStatus from "../../components/HtmlRender/HtmlRenderActifToStatus";

const PageUtilisateurs: React.FC = () => {
  const [listfilter, setListFilter] = useState<IFilterCompte>();
  const [searchParams, setSearchParams] = useState<IFilterCompteDTO|undefined>(undefined);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  //const [facettes, setFacettes] = useState<IFacetteFiltre[]>([]); // |null
  const [isDescending, setIsDescending] = useState<boolean>();
  const [sortField, setSortField] = useState("");
 
  //const [initiateDownload, setInitiateDownload] = useState(false)
  //const [csvDataToDownload, setCsvDataToDownload] = useState(null)

  //const [editeur, setediteur] = useState(""); // État local pour stocker la valeur de l'entrée

  useEffect(() => {
    const storedFilter = localStorage.getItem("IFilterComptes");
    const storedSorter = localStorage.getItem("ISortStore");

    if (storedFilter !== null && storedFilter !== undefined) { // && storedSorter !== null && storedSorter !== undefined) {
      setListFilter(JSON.parse(storedFilter));
    } else {
      setListFilter(getDefaultFilterCompte());
    }

    if (storedSorter !== null && storedSorter !== undefined) {
      const currSorter:ISorter = JSON.parse(storedSorter);
      currSorter?.orderedcolumnid && setSortField(currSorter?.orderedcolumnid);
      currSorter?.orderedasc && setIsDescending(!currSorter?.orderedasc);
    }
   
  }, []);

  useEffect(() => {
    if (listfilter && listfilter !== getDefaultFilterCompte()) {
      const _filter: IFilterCompteDTO = filterToQuery({
        ...listfilter,
        ...(sortField && { SortField: sortField }),
        ...(isDescending !== null && { IsDescending: isDescending }),
        ...(limit >= 0 && { Limit: limit }),
        ...(offset >= 0 && limit >= 0 && { Offset: offset })
      });
      setSearchParams(_filter);
      localStorage.setItem("IFilterComptes",JSON.stringify(_filter));
    }
  }, [listfilter, sortField, isDescending, offset, limit]);

  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  const { data: ComptesResult, isFetching, error } = useFetchComptesQuery(searchParams, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || searchParams === null || searchParams === undefined || listfilter === undefined,
  });


  const applyFilter = (data: IFilterCompte) => {
    //data.FacettesFiltre = [];
    setListFilter(data);
    setOffset(0);
    setLimit(10);
  }

  const actions: ILocation[] = [
    {
      PathsName: { Voir: "/utilisateurmodif/[[Id]]" },
      State: { type_access: "" },
      ClassName: "bi-receipt fs-5 mb-2",
    },
  ];

  const dataHeaderName: ITitle[] = [
    {
      Id: "Id",
      Name: "Id",
      Class: "",
      sorter: (a: ICompteList, b: ICompteList) =>
        a.Id - b?.Id,
    },
    {
      Id: "Actif",
      Name: "Statut",
      Class: "",
      sorter: (a: ICompteList, b: ICompteList) =>
        (a?.Actif === b?.Actif) ? 1 : a?.Actif ? 0 : -1,
    },
    {
      Id: "Nom",
      Name: "Nom",
      Class: "",
      sorter: (a: ICompteList, b: ICompteList) =>
        a?.Nom?.localeCompare(b?.Nom),
    },
    {
      Id: "Prenom",
      Name: "Prénom",
      Class: "",
      sorter: (a: ICompteList, b: ICompteList) =>
        a?.Prenom?.localeCompare(b?.Prenom),
    },
    {
      Id: "Email",
      Name: "Email",
      Class: "",
      sorter: (a: ICompteList, b: ICompteList) =>
        a?.Prenom?.localeCompare(b?.Prenom),
    },
    {
      Id: "DateCreation",
      Name: "Date de Création",
      Class: "desktop-only-section",
      sorter: (a: ICompteList, b: ICompteList) =>
        (a.DateCreation || "").localeCompare(b.DateCreation || "", "fr"),
    },
    {
      Id: "DateModification",
      Name: "Date de Modification",
      Class: "desktop-only-section",
      sorter: (a: ICompteList, b: ICompteList) =>
        (a.DateModification || "").localeCompare(b.DateModification || "", "fr"),
    },
    {
      Id: "NbMarques",
      Name: "Nombre de marques",
      Class: "",
    },
  ];

    //  const changeFacette = (filtre: IFacetteFiltre,checked: boolean ) => {
    //   // setSearchParams(
    //   //   filterToQuery({
    //   //     ...listfilter,
    //   //     FacettesFiltre: checked 
    //   //     ? [...(searchParams?.FacettesFiltre ?? []), filtre]
    //   //     : searchParams?.FacettesFiltre?.filter(fac => fac.filtreName !== filtre.filtreName || fac.filtreValue !== filtre.filtreValue)
    //   //   })
    //   // );
    //   setListFilter(
    //     filterToQuery({
    //       ...listfilter,
    //       FacettesFiltre: checked 
    //       ? [...(searchParams?.FacettesFiltre ?? []), filtre]
    //       : searchParams?.FacettesFiltre?.filter(fac => fac.filtreName !== filtre.filtreName || fac.filtreValue !== filtre.filtreValue)
    //     })
    //   );
    // }

  const dataItemsStyle = {
    Id: "",
    Actif: <HtmlRenderActifToStatus />,
    Nom: "",
    Prenom: "",
    DateCreation: "",
    DateModification: "",
    Email:"",
    NbMarques:"",
  };
  
return (
  <div className="container text-center">
      <div className="row pt-3 pb-2">
        <div className="col col-12 ">
          <h2 className="titreModule titre-bleu"><i className="bi-people pe-2" />Mes utilisateurs</h2>
        </div>
      </div>
      <div className="row pt-3 pb-5">
        <div className="col-12 ">
        <div className="row card mb-2 mt-2">
          {searchParams && (
            <>
              <ComptesFilter
                filter={dtoToFilter(searchParams)}
                changeFilter={applyFilter}
              />
            </>
          )}
           
        </div> 
        <div className="row ">
          {ComptesResult?.Quantite !== null && ComptesResult?.Comptes && 
            <div className="col-auto pb-3 pt-3">
              Nb de résultats :<b>&nbsp;{ComptesResult.Quantite}&nbsp;</b>
             </div>
          }
          {isFetching ? (
            <SpinnerEditeurPro />
          ) : error ? (
            <div>Error</div>
          ) : (
            <>
            <div className="d-flex justify-content-start">
                <Link to={`/NouvelUtilisateur`} className="btn btn-secondary">Déclarer un nouvel utilisateur</Link>
{/* <Button className="btn btn-secondary" >Déclarer un nouvel utilisateur</Button> */}
                </div>
            {ComptesResult?.Comptes && ComptesResult?.Quantite !== null && ComptesResult.Quantite > 0 &&
              <>
                <CpntPagination limit={limit} offset={offset} numberOfResults={ComptesResult.Quantite} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>

              <div className="card p-0 mb-2">
                <div className="table-responsive">
                  <CpntDataTable
                    data={ComptesResult && ComptesResult.Comptes ? [...ComptesResult.Comptes] : []}
                    dataHeader={dataHeaderName}
                    dataItemsStyle={dataItemsStyle}
                    actions={actions}
                    actualFilterPage="PageUtilisateurs"
                    updateSorter={setSortField}
                    updateDescending={setIsDescending}
                />
                </div>
              </div>
              <CpntPagination limit={limit} offset={offset} numberOfResults={ComptesResult.Quantite} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>
              </>}
              </>
          )}
        </div>
        </div>
      </div>
    </div>
  );
};

export default PageUtilisateurs;
